document.addEventListener('DOMContentLoaded', function () {
  const container = document.getElementById('product-grid');
  const spinner = document.getElementById('LoadMoreSpinner');
  const loadMoreBtn = document.getElementById('LoadMoreBtn');

  if (!container || !spinner) return;

  let currentPage = parseInt(container.dataset.page);
  const totalPages = parseInt(container.dataset.pages);
  let loading = false;

  // Fade-in animation
  const animateNewItems = (newProductsHTML) => {
    const temp = document.createElement('div');
    temp.innerHTML = newProductsHTML;

    const items = temp.children;
    Array.from(items).forEach((item, index) => {
      item.style.opacity = '0';
      item.style.transition = 'opacity 0.6s ease';
      setTimeout(() => {
        item.style.opacity = '1';
      }, 50 * index);
      container.appendChild(item);
    });
  };

  const loadMoreProducts = () => {
    if (loading || currentPage >= totalPages) return;
    loading = true;
    spinner.style.display = 'block';

    fetch(`${window.location.pathname}?page=${currentPage + 1}&view=ajax`)
      .then(res => res.text())
      .then(data => {
        const parser = new DOMParser();
        const newDoc = parser.parseFromString(data, 'text/html');
        const newProductsHTML = newDoc.getElementById('product-grid').innerHTML;

        animateNewItems(newProductsHTML);
        currentPage++;
        container.dataset.page = currentPage;
        spinner.style.display = 'none';
        loading = false;

        if (currentPage >= totalPages && loadMoreBtn) {
          loadMoreBtn.style.display = 'none';
        } else {
          observeLastProduct(); // Reattach observer
        }
      });
  };

  // Load more button support
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', () => loadMoreProducts());
  }

  // Observer fallback logic
  const observeLastProduct = () => {
    const allProducts = container.querySelectorAll('[data-product-card]');
    const lastProduct = allProducts[allProducts.length - 1];
    if (!('IntersectionObserver' in window)) {
      loadMoreBtn.style.display = 'block';
      return;
    }

    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        loadMoreProducts();
      }
    }, {
      rootMargin: '200px',
    });

    if (lastProduct) observer.observe(lastProduct);
  };

  observeLastProduct();
});
